var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "la:chalkboard-teacher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.625 6.9375V9.25H30.0625V27.75H13.875V30.0625H34.6875V27.75H32.375V6.9375H4.625ZM9.25231 10.4062C8.02678 10.4105 6.85263 10.8991 5.98583 11.7655C5.11903 12.6318 4.62988 13.8057 4.625 15.0312C4.625 17.5738 6.71087 19.6562 9.25231 19.6562C10.4772 19.6514 11.6505 19.1625 12.5165 18.2961C13.3824 17.4297 13.8707 16.2562 13.875 15.0312C13.875 12.491 11.7914 10.4062 9.25231 10.4062ZM16.1875 11.5625V13.875H21.9688V11.5625H16.1875ZM24.2812 11.5625V13.875H27.75V11.5625H24.2812ZM9.25231 12.7188C10.5404 12.7188 11.5625 13.7397 11.5625 15.0312C11.5625 16.3263 10.5415 17.3438 9.25231 17.3438C7.95731 17.3438 6.9375 16.3263 6.9375 15.0312C6.9375 13.7397 7.95847 12.7188 9.25231 12.7188ZM16.1875 16.1875V18.5H27.75V16.1875H16.1875ZM4.625 20.8125V30.0625H6.9375V23.125H10.4062V30.0625H12.7188V23.8858L15.1053 25.1484C15.7817 25.5069 16.5945 25.5057 17.2697 25.1484V25.1508L21.3513 22.992L20.2725 20.9455L16.1898 23.1042L12.6101 21.2149C12.1105 20.9509 11.554 20.8128 10.989 20.8125H4.625Z",
    fill: "#065AD8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentor);
export default __webpack_public_path__ + "static/media/Mentor.f9dbf3a1348df3980637ca5690e29bd6.svg";
export { ForwardRef as ReactComponent };